import { t } from 'localization/utils/t';

export const TP = 'timeline.enums.constants';

export const DEFAULT_TIMELINE_PAGE_HEADER_TEXT = {
  value: t(`${TP}.timlineSneakerRelease`, 'Timeline: Sneaker Releases'),
  TK: 'timlineSneakerRelease',
  TP,
};
export const DEFAULT_FUTURE_TIMELINE_PAGE_HEADER_TEXT = {
  value: t(`${TP}.timelineUpcomingRelease`, 'Timeline: Upcoming Releases'),
  TK: 'timelineUpcomingRelease',
  TP,
};
export const PRESENT = 'present';
export const FUTURE = 'future';
export const PAST_YEAR = 'pastYear';
export const TIMELINE_PATHNAME = '/timeline/[[...timelineYear]]';

export const DEFAULT_TIMELINE_PAGE_PRESENT_DESCRIPTION = {
  value: t(
    `${TP}.defaultTimelinePagePresentDescription`,
    'Discover the greatest sneakers from 1985 to now. A calendar of sneaker releases, future classics and iconic styles from <a href="/brand/air-jordan">Air Jordan</a>, <a href="/collections/yeezy">Yeezy</a>, <a href="/brand/nike">Nike</a>, and <a href="/sneakers">more</a>.',
  ),
  TK: 'defaultTimelinePagePresentDescription',
  TP,
};

export const DEFAULT_TIMELINE_PAGE_FUTURE_DESCRIPTION = {
  value: t(
    `${TP}.defaultTimelinePageFutureDescription`,
    'Discover future classics and upcoming sneaker releases from <a href="/brand/air-jordan">Air Jordan</a>, <a href="/collections/yeezy">Yeezy</a>, <a href="/brand/nike">Nike</a>, and <a href="/sneakers">more</a>.',
  ),
  TK: 'defaultTimelinePageFutureDescription',
  TP,
};
